if (!customElements.get('rm-retail-header')) customElements.define('rm-retail-header', class extends HTMLElement {
 connectedCallback() {
  this.update = () => {
   this.classList.toggle('is-scrolled', window.scrollY > 36);
   document.documentElement.style.setProperty('--rm-header-height', `${this.getBoundingClientRect().height}px`);
  };
  this.keydown = e => { if(e.key === 'Escape') {const d=e.target.closest('details'); if(d){d.open=false;d.querySelector('summary').focus();}} };
  this.outside = e => { if(!this.contains(e.target)) this.querySelectorAll('details[open]').forEach(d=>d.open=false); };
  this.onToggle = e => {if(e.target.open && e.target.matches('.rm-header-nav > details'))this.querySelectorAll('.rm-header-nav > details[open]').forEach(d=>{if(d!==e.target)d.open=false;});};
  this.addEventListener('keydown',this.keydown);this.addEventListener('toggle',this.onToggle,true);
  document.addEventListener('click',this.outside);window.addEventListener('scroll',this.update,{passive:true});
  this.resize=new ResizeObserver(this.update);this.resize.observe(this);this.update();
 }
 disconnectedCallback(){this.resize.disconnect();window.removeEventListener('scroll',this.update);document.removeEventListener('click',this.outside);this.removeEventListener('keydown',this.keydown);this.removeEventListener('toggle',this.onToggle,true);}
});
